module.exports = __webpack_public_path__ + "img/clothing186.e2828bac.jpg";